import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  private _snackBar = inject(MatSnackBar);

  constructor() { }

  setItemToLocalStorage(key: string, value: string): void {
    localStorage.setItem(btoa(key), btoa(value));
  }

  getItemFromLocalStorage(key: string): string {
    return atob(localStorage.getItem(btoa(key)) || '');
  }

  removeItemFromLocalStorage(key: string): void {
    localStorage.removeItem(btoa(key));
  }

  openSnackBar(message: string, action: string, type: 'success' | 'error'): void {
    this._snackBar.open(message, action, {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'success' ? 'success-snackbar' : 'error-snackbar',
      duration: 5000
    });
  }
}
